import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import {
    LAND_WIDTH_OPTIONS,
    LAND_DEEP_OPTIONS,
  } from "@/constants/builderEstimatorToolHeroOptions";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import BuilderEstimatorStepTitle from "./BuilderEstimatorStepTitle.vue";
  interface Props {
    builderLogo: string;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorToolHero',
  props: {
    builderLogo: {}
  },
  emits: ["update:preferredLocation", "update:landFilter"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const { isDesktop } = useIsDesktop(980);

  const preferredLocation = ref("");
  const landWidth = ref<string | null>(null);
  const landDepth = ref<string | null>(null);

  const emit = __emit;

  const updateLandDimension = (
    dimensionType: "width" | "depth",
    value: string
  ) => {
    dimensionType === "width"
      ? (landWidth.value = value)
      : (landDepth.value = value);

    emitUpdatedLandFilter();
  };

  const emitUpdatedLandFilter = () => {
    if (landWidth.value && landDepth.value) {
      emit("update:landFilter", {
        width: landWidth.value === "Any" ? "" : landWidth.value,
        length: landDepth.value === "Any" ? "" : landDepth.value,
      });
    }
  };

  watch(preferredLocation, () => {
    emit("update:preferredLocation", preferredLocation.value);
  });

  watch([landWidth, landDepth], () => emitUpdatedLandFilter());

const __returned__ = { props, isDesktop, preferredLocation, landWidth, landDepth, emit, updateLandDimension, emitUpdatedLandFilter, ref, watch, get useIsDesktop() { return useIsDesktop }, get LAND_WIDTH_OPTIONS() { return LAND_WIDTH_OPTIONS }, get LAND_DEEP_OPTIONS() { return LAND_DEEP_OPTIONS }, DropDown, BuilderEstimatorStepTitle }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})